var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'dark-mode':_vm.isDarkMode},attrs:{"id":"app"}},[_c('b-loading',{attrs:{"active":_vm.isFetching,"can-cancel":false,"is-full-page":true}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }